// source: plant.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var device_type_pb = require('./device_type_pb.js');
goog.object.extend(proto, device_type_pb);
goog.exportSymbol('proto.pb.DeviceInfo', null, global);
goog.exportSymbol('proto.pb.DeviceInfo.SupportedBy', null, global);
goog.exportSymbol('proto.pb.Plant', null, global);
goog.exportSymbol('proto.pb.PlantInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Plant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.Plant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Plant.displayName = 'proto.pb.Plant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.PlantInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.PlantInfo.repeatedFields_, null);
};
goog.inherits(proto.pb.PlantInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.PlantInfo.displayName = 'proto.pb.PlantInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.DeviceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pb.DeviceInfo.repeatedFields_, null);
};
goog.inherits(proto.pb.DeviceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.DeviceInfo.displayName = 'proto.pb.DeviceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.DeviceInfo.SupportedBy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.DeviceInfo.SupportedBy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.DeviceInfo.SupportedBy.displayName = 'proto.pb.DeviceInfo.SupportedBy';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Plant.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Plant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Plant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Plant.toObject = function(includeInstance, msg) {
  var f, obj = {
    ctrl0id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ctrl0model: jspb.Message.getFieldWithDefault(msg, 2, ""),
    siteid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    plantid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    plantfolder: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Plant}
 */
proto.pb.Plant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Plant;
  return proto.pb.Plant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Plant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Plant}
 */
proto.pb.Plant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtrl0id(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtrl0model(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantfolder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Plant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Plant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Plant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Plant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCtrl0id();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCtrl0model();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSiteid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlantid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlantfolder();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string Ctrl0ID = 1;
 * @return {string}
 */
proto.pb.Plant.prototype.getCtrl0id = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Plant} returns this
 */
proto.pb.Plant.prototype.setCtrl0id = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Ctrl0Model = 2;
 * @return {string}
 */
proto.pb.Plant.prototype.getCtrl0model = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Plant} returns this
 */
proto.pb.Plant.prototype.setCtrl0model = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string SiteID = 3;
 * @return {string}
 */
proto.pb.Plant.prototype.getSiteid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Plant} returns this
 */
proto.pb.Plant.prototype.setSiteid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PlantID = 4;
 * @return {string}
 */
proto.pb.Plant.prototype.getPlantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Plant} returns this
 */
proto.pb.Plant.prototype.setPlantid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PlantFolder = 5;
 * @return {string}
 */
proto.pb.Plant.prototype.getPlantfolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.Plant} returns this
 */
proto.pb.Plant.prototype.setPlantfolder = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.PlantInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.PlantInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.PlantInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.PlantInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.PlantInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    ctrl0id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    plantfolder: jspb.Message.getFieldWithDefault(msg, 2, ""),
    deviceinfoList: jspb.Message.toObjectList(msg.getDeviceinfoList(),
    proto.pb.DeviceInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.PlantInfo}
 */
proto.pb.PlantInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.PlantInfo;
  return proto.pb.PlantInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.PlantInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.PlantInfo}
 */
proto.pb.PlantInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtrl0id(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlantfolder(value);
      break;
    case 3:
      var value = new proto.pb.DeviceInfo;
      reader.readMessage(value,proto.pb.DeviceInfo.deserializeBinaryFromReader);
      msg.addDeviceinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.PlantInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.PlantInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.PlantInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.PlantInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCtrl0id();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlantfolder();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDeviceinfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.pb.DeviceInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Ctrl0ID = 1;
 * @return {string}
 */
proto.pb.PlantInfo.prototype.getCtrl0id = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.PlantInfo} returns this
 */
proto.pb.PlantInfo.prototype.setCtrl0id = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PlantFolder = 2;
 * @return {string}
 */
proto.pb.PlantInfo.prototype.getPlantfolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.PlantInfo} returns this
 */
proto.pb.PlantInfo.prototype.setPlantfolder = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DeviceInfo deviceInfo = 3;
 * @return {!Array<!proto.pb.DeviceInfo>}
 */
proto.pb.PlantInfo.prototype.getDeviceinfoList = function() {
  return /** @type{!Array<!proto.pb.DeviceInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.DeviceInfo, 3));
};


/**
 * @param {!Array<!proto.pb.DeviceInfo>} value
 * @return {!proto.pb.PlantInfo} returns this
*/
proto.pb.PlantInfo.prototype.setDeviceinfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.pb.DeviceInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.DeviceInfo}
 */
proto.pb.PlantInfo.prototype.addDeviceinfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.pb.DeviceInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.PlantInfo} returns this
 */
proto.pb.PlantInfo.prototype.clearDeviceinfoList = function() {
  return this.setDeviceinfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pb.DeviceInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.DeviceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.DeviceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.DeviceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.DeviceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    idx: jspb.Message.getFieldWithDefault(msg, 1, 0),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    model: jspb.Message.getFieldWithDefault(msg, 3, ""),
    supported: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    supportedbyList: jspb.Message.toObjectList(msg.getSupportedbyList(),
    proto.pb.DeviceInfo.SupportedBy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.DeviceInfo}
 */
proto.pb.DeviceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.DeviceInfo;
  return proto.pb.DeviceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.DeviceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.DeviceInfo}
 */
proto.pb.DeviceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIdx(value);
      break;
    case 2:
      var value = /** @type {!proto.pb.DeviceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupported(value);
      break;
    case 5:
      var value = new proto.pb.DeviceInfo.SupportedBy;
      reader.readMessage(value,proto.pb.DeviceInfo.SupportedBy.deserializeBinaryFromReader);
      msg.addSupportedby(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.DeviceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.DeviceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.DeviceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.DeviceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdx();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSupported();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSupportedbyList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.pb.DeviceInfo.SupportedBy.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.DeviceInfo.SupportedBy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.DeviceInfo.SupportedBy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.DeviceInfo.SupportedBy.toObject = function(includeInstance, msg) {
  var f, obj = {
    deviceid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    templateid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    os: jspb.Message.getFieldWithDefault(msg, 3, ""),
    baseimage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.DeviceInfo.SupportedBy}
 */
proto.pb.DeviceInfo.SupportedBy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.DeviceInfo.SupportedBy;
  return proto.pb.DeviceInfo.SupportedBy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.DeviceInfo.SupportedBy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.DeviceInfo.SupportedBy}
 */
proto.pb.DeviceInfo.SupportedBy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.DeviceInfo.SupportedBy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.DeviceInfo.SupportedBy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.DeviceInfo.SupportedBy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTemplateid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBaseimage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string DeviceID = 1;
 * @return {string}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.getDeviceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.DeviceInfo.SupportedBy} returns this
 */
proto.pb.DeviceInfo.SupportedBy.prototype.setDeviceid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string TemplateID = 2;
 * @return {string}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.getTemplateid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.DeviceInfo.SupportedBy} returns this
 */
proto.pb.DeviceInfo.SupportedBy.prototype.setTemplateid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string OS = 3;
 * @return {string}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.DeviceInfo.SupportedBy} returns this
 */
proto.pb.DeviceInfo.SupportedBy.prototype.setOs = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string BaseImage = 4;
 * @return {string}
 */
proto.pb.DeviceInfo.SupportedBy.prototype.getBaseimage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.DeviceInfo.SupportedBy} returns this
 */
proto.pb.DeviceInfo.SupportedBy.prototype.setBaseimage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 IDX = 1;
 * @return {number}
 */
proto.pb.DeviceInfo.prototype.getIdx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pb.DeviceInfo} returns this
 */
proto.pb.DeviceInfo.prototype.setIdx = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional DeviceType Type = 2;
 * @return {!proto.pb.DeviceType}
 */
proto.pb.DeviceInfo.prototype.getType = function() {
  return /** @type {!proto.pb.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pb.DeviceType} value
 * @return {!proto.pb.DeviceInfo} returns this
 */
proto.pb.DeviceInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Model = 3;
 * @return {string}
 */
proto.pb.DeviceInfo.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pb.DeviceInfo} returns this
 */
proto.pb.DeviceInfo.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool Supported = 4;
 * @return {boolean}
 */
proto.pb.DeviceInfo.prototype.getSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.DeviceInfo} returns this
 */
proto.pb.DeviceInfo.prototype.setSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated SupportedBy supportedBy = 5;
 * @return {!Array<!proto.pb.DeviceInfo.SupportedBy>}
 */
proto.pb.DeviceInfo.prototype.getSupportedbyList = function() {
  return /** @type{!Array<!proto.pb.DeviceInfo.SupportedBy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pb.DeviceInfo.SupportedBy, 5));
};


/**
 * @param {!Array<!proto.pb.DeviceInfo.SupportedBy>} value
 * @return {!proto.pb.DeviceInfo} returns this
*/
proto.pb.DeviceInfo.prototype.setSupportedbyList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.pb.DeviceInfo.SupportedBy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pb.DeviceInfo.SupportedBy}
 */
proto.pb.DeviceInfo.prototype.addSupportedby = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.pb.DeviceInfo.SupportedBy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pb.DeviceInfo} returns this
 */
proto.pb.DeviceInfo.prototype.clearSupportedbyList = function() {
  return this.setSupportedbyList([]);
};


goog.object.extend(exports, proto.pb);
